export const getOS = (navigator: any) => {
    if (navigator.userAgent.indexOf('Win') != -1) return 'Windows';
    else if (navigator.userAgent.indexOf('Mac') != -1) return 'MacOS';
    else if (navigator.userAgent.indexOf('X11') != -1) return 'UNIX';
    else if (navigator.userAgent.indexOf('Linux') != -1) return 'Linux';
    else return "Unknown OS";
};
